import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import { watchEffect } from 'vue';

export type SharedFoldableEmits = {
	(e: 'update:open', val: boolean): void
};

export type SharedFoldableProps = {
	open?: boolean
	icon?: Orion.Icon
	fontIcon?: string
	color?: Orion.Color | Orion.ColorAlt
};

export default class SharedFoldableSetup extends BaseSetup {

	static readonly defaultProps = { color: 'grey' as Orion.Color | Orion.ColorAlt };

	@Reactive private readonly state = { isOpen: false };

	get rgbColor () { return `var(--rgb-${this.props.color})` }

	get isOpen () { return this.state.isOpen }
	set isOpen (val) {
		this.state.isOpen = val;
		this.emits('update:open', val);
	}

	constructor (
		private props: SharedFoldableProps,
		private emits: SharedFoldableEmits,
	) {
		super();

		watchEffect(() => this.state.isOpen = !!this.props.open);
	}

}
